import { COLORS } from '../Color';
import { useEffect, useState } from 'react';
import BoardService from '../../../service/board/Board';
import { styled } from 'styled-components';

const BoardDetail = ({
  setBoardType,
  articleidx,
  setArticleData,
}: {
  setBoardType: any;
  articleidx: number;
  setArticleData: any;
}) => {
  const [commentData, setCommentData] = useState<any>([]);
  const [detailData, setDetailData] = useState<any>({});
  const [comment, setComment] = useState<string>('');
  const [reply, setReply] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [activeReplyCommentId, setActiveReplyCommentId] = useState<
    number | null
  >(null);

  const getDetailData = async (articleidx: number) => {
    try {
      const res = await BoardService.detail(articleidx);
      if (res.status === 'success') {
        setDetailData(res.data);
        setArticleData(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getCommentData = async (
    articleidx: number,
    limit: number,
    offset: number,
  ) => {
    try {
      const res = await BoardService.commentList(articleidx, limit, offset);
      if (res.status === 'success') {
        setCommentData(res.data.list);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getDetailData(articleidx);
  }, []);

  useEffect(() => {
    getCommentData(articleidx, 100, 0);
  }, []);

  useEffect(() => {
    setUserName(localStorage.getItem('userName') || '');
  }, []);

  const changeTimeFormat = (time: string) => {
    return String(time).split('T')[0];
  };

  const deleteArticle = async () => {
    try {
      const res = await BoardService.delete(detailData.articleidx);
      if (res.status === 'success') {
        alert('삭제되었습니다.');
        setBoardType('List');
      }
    } catch (e) {
      console.log(e);
    }
  };

  const showAlert = () => {
    const confirmed = window.confirm('정말로 삭제하시겠습니까?');
    if (confirmed) {
      deleteArticle();
    }
  };

  const commentWrite = async (idx: number | null, content: string) => {
    if (content === '') {
      alert('댓글을 입력해주세요.');
      return;
    }
    try {
      const res = await BoardService.commentWrite(detailData.articleidx, {
        commentidx: idx,
        content: content,
      });
      if (res.status === 'success') {
        alert('댓글이 등록되었습니다.');
        setComment('');
        setReply('');
        getCommentData(articleidx, 100, 0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReplyClick = (commentId: number) => {
    setActiveReplyCommentId((prevId) =>
      prevId === commentId ? null : commentId,
    );
  };

  const deleteComment = async (commentIdx: number) => {
    const confirmed = window.confirm('정말로 삭제하시겠습니까?');
    if (confirmed) {
      try {
        const res = await BoardService.commentDelete(commentIdx);
        alert('삭제되었습니다.');
        getCommentData(articleidx, 100, 0);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <Container>
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column' as 'column',
        paddingInline: '16px',
      }}
    >
      <div style={styles.titleSection}>
      <span style={styles.infoText}>{detailData.category}</span>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'row',
                    }}
                  >
                    <span style={styles.titleText}>{detailData.title}</span>
                    {(() => {
                      const twoWeeksAgo = new Date();
                      twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
                      const writeDate = new Date(detailData.write_time);

                      return writeDate >= twoWeeksAgo ? (
                        <span
                          style={{
                            marginLeft: '8px',
                            backgroundColor: '#2868D2',
                            color: '#FFFFFF',
                            borderRadius: '4px',
                            fontSize: '14px',
                            padding: '0px 4px',
                            width: '20px',
                            fontWeight: '700',
                          }}
                        >
                          N
                        </span>
                      ) : null;
                    })()}
                  </div>
        <div style={styles.info}>
          <span style={styles.infoText}>
              {detailData
                ? changeTimeFormat(detailData.write_time)
                : '-'}
              </span>
            </div>
          </div>
      <div style={styles.contentSection}>
        <div style={styles.contentText}
          dangerouslySetInnerHTML={{ __html: detailData.content }} />
      </div>
      <div style={styles.buttonContainer}>
        <div
          style={styles.toHomeBtn}
          onClick={() => {
            setBoardType('List');
          }}
        >
          <span style={styles.btnText}>목록으로</span>
        </div>
      </div>
    </div>
    </Container>
  );
};

export default BoardDetail;

const Container = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
`;

const styles = {
  titleSection: {
    width: '100%',
    paddingTop: '32px',
    // paddingInline: '16px',
    paddingBottom: '16px',
    gap: 24,
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
  },
  titleText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '26.1px',
    padding: '16px 0px',
  },
  info: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
  infoText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    letterSpacing: -0.7,
    color: COLORS.tertiary,
  },
  contentSection: {
    width: '100%',
    paddingTop: '16px',
    paddingBottom: '16px',
    borderBottom: '1px solid #E1E2E4',
  },
  contentText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '23.2px',
    letterSpacing: -0.8,
    color: COLORS.secondary,
    whiteSpace: 'pre-wrap' as 'pre-wrap',
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 16,
    marginTop: '48px',
  },
  toHomeBtn: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '48px',
    borderColor: COLORS.primary,
    borderRadius: 8,
    width: '147px',
    height: '48px',
    cursor: 'pointer',
    backgroundColor: '#222222',
  },
  btnText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: '#FFFFFF',
  },
  replyContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 32,
  },
  replyTitle: {
    width: '100%',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '26.1px',
    color: COLORS.primary,
    paddingTop: '32px',
    paddingBottom: '16px',
    borderBottomWidth: 1,
    borderBottomColor: COLORS.borderGray,
  },
  textAreaBox: {
    width: '100%',
    height: '160px',
    padding: '24px',
    border: '1px solid ' + COLORS.primary,
    borderColor: COLORS.primary,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 8,
    backgroundColor: '#fff',
  },
  textArea: {
    width: '100%',
  },
  userName: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '20.3px',
    color: '#000',
  },
  registerBtn: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: '#fff',
    borderRadius: 8,
    width: '160px',
    height: '48px',
    backgroundColor: COLORS.primary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  commentList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
    marginTop: '32px',
    marginBottom: '120px',
  },
  commentItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  comment: {
    width: '100%',
    padding: '16px',
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 24,
  },
  commentWriter: {
    width: '120px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '20.3px',
    color: COLORS.primary,
  },
  replyWriter: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '20.3px',
    color: COLORS.primary,
  },
  commentContent: {
    flex: 1,
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: COLORS.primary,
    display: 'flex',
    flexWrap: 'wrap' as 'wrap',
    whiteSpace: 'pre-wrap' as 'pre-wrap',
  },
  commentInput: {
    borderWidth: 0,
    borderColor: COLORS.primary,
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    height: '100%',
    width: '100%',
    resize: 'none' as 'none',
  },
  replyInput: {
    borderWidth: 0,
    borderColor: COLORS.primary,
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    height: '100%',
  },
  replybtn: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: COLORS.tertiary,
  },
  regdate: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: COLORS.tertiary,
  },

  reply: {
    width: '100%',
    paddingTop: '24px',
    paddingInline: '16px',
    paddingBottom: '16px',
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
    backgroundColor: COLORS.lightGray,
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 24,
    alignItems: 'center',
  },
  writeReplyBox: {
    width: '100%',
    backgroundColor: COLORS.lightGray,
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 8,
    paddingTop: '24px',
    paddingInline: '16px',
    paddingBottom: '16px',
    borderBottom: '1px solid ' + COLORS.borderGray,
    borderBottomColor: COLORS.borderGray,
  },
  noCommentData: {
    width: '100%',
    textAlign: 'center' as 'center',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    color: COLORS.tertiary,
    paddingBlock: '26px',
    marginBottom: '120px',
  },
};
